<template>
    <GenericMultiStepModal :header-icon="IconSource.Food" :is-final-step="false" @closing="onModalClose">
        <template #default="scope">
            <slot v-bind="scope" />
        </template>
        <template #component="scope">
            <component :is="currentStep.component" v-model:mix="form" @submit="next" @close="scope.close"></component>
        </template>
    </GenericMultiStepModal>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue';
import GenericMultiStepModal from '@/components/common/GenericMultiStepModal.vue';
import MixPrices from '@/views/dashboard/feed/feedMixes/editMixModal/MixPrices.vue';
import DeleteSuccess from '@/views/dashboard/feed/feedMixes/editMixModal/DeleteSuccess.vue';
import { Mix } from '@/types';
import useResettableForm from '@/components/common/composables/useResettableForm';
import MultiStepFormHeaderIcon from '@/components/common/MultiStepFormHeaderIcon.vue';
import useMultiSteps from '@/components/common/composables/useMultiSteps';
import CloseModalButton from '@/components/common/CloseModalButton.vue';

export default defineComponent({
    components: { GenericMultiStepModal, MultiStepFormHeaderIcon, CloseModalButton },
    props: {
        mix: {
            type: Object as () => Mix,
            required: true,
        },
    },
    setup(props) {
        const resettableForm = useResettableForm().setInitial(props.mix);
        const form = resettableForm.getInstance();

        watch(
            () => props.mix,
            (newValue) => {
                if (newValue) {
                    resettableForm.setInitial(props.mix);
                }
            }
        );

        const multiSteps = useMultiSteps([
            {
                component: MixPrices,
            },
            {
                component: DeleteSuccess,
            },
        ]).setInitial(0);

        const onModalClose = () => {
            multiSteps.reset();
            resettableForm.reset();
        };

        return {
            ...multiSteps,
            onModalClose,
            form,
        };
    },
});
</script>
